import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  root: {
    width: '100%',
  },
  container: {
    position: 'relative',
    '&[aria-expanded="true"] $selectedItemSubtitle': {
      display: 'none',
    },
  },
  paper: {
    marginTop: -3,
  },
  selectedItemSubtitle: {
    display: 'flex',
    width: '80%',
    justifyContent: 'space-between',
    color: custom.grey[2],
    fontSize: 12,
    position: 'relative',
    top: -35,
    marginLeft: 46,
    marginBottom: -20,
    zIndex: -1,
  },
  withSubLabels: {
    height: 82,
  },
  inputWithSubLabels: {
    height: 70,
    '& > *:not(fieldset)': {
      position: 'relative',
      top: -10,
    },
  },
  inputRoot: {
    '& ::placeholder': {
      opacity: 1,
      color: custom.grey[4],
      fontSize: 13,
    },
    '&.Mui-error ::placeholder': {
      color: custom.status.danger.contrastText,
      fontWeight: 600,
    },
  },
  notchedOutline: {},
  focused: {},
}));
